import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Delete, ScanLine, Lock } from "lucide-react";

export default function PosLogin() {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const { user, setUserFromToken } = useApp();
  const nav = useNavigate();

  useEffect(() => {
    if (user?.role === "worker") nav("/arka", { replace: true });
    if (user?.role === "admin") nav("/arka", { replace: true });
  }, [user, nav]);

  const submit = async (c) => {
    setLoading(true);
    try {
      const r = await api.post("/pos/login", { code: c });
      localStorage.setItem("hg_token", r.data.token);
      setUserFromToken(r.data.user);
      toast.success(`Mirë se erdhe, ${r.data.user.name}`);
      nav("/arka", { replace: true });
    } catch (e) {
      toast.error(e.response?.data?.detail || "Kod i pavlefshëm");
      setCode("");
    }
    setLoading(false);
  };

  const press = (v) => {
    if (loading) return;
    const next = (code + v).slice(0, 6);
    setCode(next);
    if (next.length === 6) submit(next);
  };
  const back = () => setCode(prev => prev.slice(0, -1));

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col items-center justify-center px-4 py-6">
      <div className="max-w-sm w-full">
        <img src="/logo-hidrogv.png" alt="HidroGV" className="h-20 w-auto mx-auto mb-6 object-contain" />
        <div className="inline-flex items-center justify-center w-14 h-14 bg-[#FFD600] text-black mb-3 mx-auto rounded-full" style={{ display: "block", margin: "0 auto 12px" }}>
          <div className="w-14 h-14 flex items-center justify-center"><ScanLine size={28} /></div>
        </div>
        <div className="text-center mb-6">
          <div className="text-xs uppercase tracking-widest text-[#FFD600] font-bold mb-1">Arka / Shitja</div>
          <h1 className="font-display text-3xl uppercase leading-none">Hyr me kod</h1>
          <div className="text-sm text-neutral-400 mt-2">Shkruaj 6 shifrat e kodit tënd</div>
        </div>

        <div className="hg-card p-5">
          <div className="flex justify-center gap-2 mb-6" data-testid="pos-code-display">
            {[0, 1, 2, 3, 4, 5].map(i => (
              <div key={i} className={`w-10 h-12 border-2 flex items-center justify-center text-2xl font-bold ${code.length > i ? "border-[#FFD600] bg-[#FFD600]/10" : "border-[#262626]"}`}>
                {code[i] ? "•" : ""}
              </div>
            ))}
          </div>

          <div className="grid grid-cols-3 gap-3">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(n => (
              <button key={n} onClick={() => press(String(n))} data-testid={`pos-key-${n}`}
                className="h-16 text-2xl font-bold border border-[#262626] hover:bg-[#FFD600] hover:text-black active:bg-[#FFD600] active:text-black transition-colors">
                {n}
              </button>
            ))}
            <button onClick={back} data-testid="pos-key-back"
              className="h-16 flex items-center justify-center border border-[#262626] hover:bg-red-500 hover:text-white transition-colors">
              <Delete size={22} />
            </button>
            <button onClick={() => press("0")} data-testid="pos-key-0"
              className="h-16 text-2xl font-bold border border-[#262626] hover:bg-[#FFD600] hover:text-black transition-colors">
              0
            </button>
            <div className="h-16 flex items-center justify-center">
              {loading && <Lock size={18} className="text-[#FFD600] animate-pulse" />}
            </div>
          </div>
        </div>

        <div className="text-center text-xs text-neutral-500 mt-6">
          © {new Date().getFullYear()} HidroGV — POS v1.0
        </div>
      </div>
    </div>
  );
}
